// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__c91ME","name":"styles_name__Du_I4","phone":"styles_phone__1Rale"};